import { render, staticRenderFns } from "./Popup-base.vue?vue&type=template&id=19754bd9&"
import script from "./Popup-base.vue?vue&type=script&lang=ts&"
export * from "./Popup-base.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports